import { Box, Flex, Text } from '@chakra-ui/react'

import { Icon } from '../../../../components/Icon'

interface IAuctionScreenBadgesProps {
  auctionEnded: boolean
  isConnected: boolean
  peopleCount: number
}

/**
 * Os dois selos do topo da tela: o "AO VIVO" e a contagem de pessoas no evento.
 *
 * O ponto pulsante dentro do selo reflete a conexão com o WebSocket — quando ela cai a
 * tela continua atualizando por polling, e o ponto parado é o único aviso disso.
 */
export function AuctionScreenBadges({ auctionEnded, isConnected, peopleCount }: IAuctionScreenBadgesProps) {
  return (
    <Flex align="center" gap={3}>
      <Flex
        align="center"
        gap={2}
        bg={auctionEnded ? 'whiteAlpha.300' : 'magenta.500'}
        px="0.75vw"
        py="0.2vw"
        borderRadius="full"
      >
        <Box
          w="0.4vw"
          h="0.4vw"
          minW="5px"
          minH="5px"
          borderRadius="full"
          bg="white"
          opacity={isConnected ? 1 : 0.45}
          sx={
            isConnected && !auctionEnded
              ? {
                  animation: 'auctionLivePulse 2s infinite',
                  '@keyframes auctionLivePulse': { '0%, 100%': { opacity: 1 }, '50%': { opacity: 0.3 } }
                }
              : {}
          }
        />
        <Text fontSize="clamp(10px, 0.72vw, 16px)" fontWeight="700" letterSpacing="0.08em" color="white">
          {auctionEnded ? 'ENCERRADO' : 'AO VIVO'}
        </Text>
      </Flex>

      <Flex align="center" gap={1.5} bg="whiteAlpha.200" px="0.75vw" py="0.2vw" borderRadius="full">
        <Icon name="lni lni-users" color="white" fontSize="clamp(10px, 0.72vw, 16px)" />
        <Text fontSize="clamp(10px, 0.72vw, 16px)" fontWeight="700" color="white">
          {peopleCount}
        </Text>
      </Flex>
    </Flex>
  )
}
